module.exports = __webpack_public_path__ + "img/tv.4a76a6cc.png";